import { CONSENT_ADVERTISING, eventName as resolveEventName } from "../events";
import { injectScript } from "./script";

const TTQ_METHODS = [
    "page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group",
    "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent",
];

/**
 * TikTok Pixel (snippet oficial events.js). Só com consentimento de advertising.
 */
export default {
    name: "tiktok",

    isAllowed(config, allowed) {
        return !!(config && config.pixel_id) && allowed(CONSENT_ADVERTISING);
    },

    init(config) {
        if (!window.ttq) {
            const ttq = [];
            window.TiktokAnalyticsObject = "ttq";
            ttq.methods = TTQ_METHODS;
            ttq.setAndDefer = function (target, method) {
                target[method] = function () {
                    target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
                };
            };
            TTQ_METHODS.forEach((method) => ttq.setAndDefer(ttq, method));
            ttq.instance = function (id) {
                const instance = ttq._i[id] || [];
                TTQ_METHODS.forEach((method) => ttq.setAndDefer(instance, method));
                return instance;
            };
            ttq.load = function (id, options) {
                const src = "https://analytics.tiktok.com/i18n/pixel/events.js";
                ttq._i = ttq._i || {};
                ttq._i[id] = [];
                ttq._i[id]._u = src;
                ttq._t = ttq._t || {};
                ttq._t[id] = +new Date();
                ttq._o = ttq._o || {};
                ttq._o[id] = options || {};
                injectScript(`${src}?sdkid=${encodeURIComponent(id)}&lib=ttq`);
            };
            window.ttq = ttq;
        }

        window.ttq.load(config.pixel_id);
        window.ttq.page();
    },

    send(eventName, payload, config) {
        const nativeName = resolveEventName("tiktok", config, eventName);
        if (!nativeName || !window.ttq) {
            return;
        }

        window.ttq.track(
            nativeName,
            {
                content_type: "product",
                content_id: payload.job_id ? String(payload.job_id) : undefined,
                content_name: payload.job_title,
            },
            { event_id: payload.event_id }
        );
    },
};
